export const productId = {
  ['Grabaut_Zero_MB']: 'HBMX_289',
  ['Grabaut_Strike2_MB']: 'HBMX_289',
  ['Grabaut_2NOW_MB']: 'HBMX_295',
  ['Grabaut_P_MB']: 'HBMX_400',
  ['Grabaut_AIR_MB']: 'HBMX_7',
  ['Grabaut_VIVA_MB']: 'HBMX_401',
  ['Grabaut_VIVA_PLUS_MB']: 'HBMX_402',
};
